<div class="dalog-header-cust">
    <h2>Request a Call</h2>
    <button type="button" class="btn-cust-close" (click)="navService.openSideNav({ toogle: true })">
    <i class="icon-close"></i>
  </button>
</div>
<!-- <button class="btn-close" (click)="navService.openSideNav({ toogle: true })">
  <mat-icon>close</mat-icon>
</button>
<mat-toolbar class="mat-elevation-z0">
  <mat-toolbar-row>
    <div class="notificard">
      <h2>
        <img src="assets/images/request-a-call.svg" alt="" class="me-2" /> REQUEST A
        CALL
      </h2>
    </div>
  </mat-toolbar-row>
</mat-toolbar> -->
<div class="side-drawer-content request">
  <h3>We would love to listen to you!</h3>
  <div [formGroup]="formGroup" class="px-3 py-1">
    <div class="col-lg-12 col-12">
      <label
        >About @if (Global.isInputRuleAvailable(formGroup, 'requestText',
        'required')) { <span class="text-danger">*</span>}
      </label>
      <mat-form-field class="w-100">
        <textarea
          matInput
          formControlName="requestText"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'requestText')"
          placeholder="Type Here"
        >
        </textarea>
        @if (!Global.isInputRuleValid(formGroup, 'requestText', 'required')) {
        <mat-error>This field is required</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >Attachment @if (Global.isInputRuleAvailable(formGroup, 'documentData',
        'required')) { <span class="text-danger">*</span>}
      </label>
      <div
        class="browse-file"
        [class.is-invalid]="!Global.isInputValid(formGroup, 'documentData')"
      >
        @if (formGroup.value?.documentData) {
        <p>
          {{ formGroup.value?.documentName ?? "File Selected" }}
          <!-- <a matTooltip="View" (click)="Global.openBase64File(formGroup.value?.documentData)"
                              class="mx-1"><mat-icon>attachment</mat-icon></a> -->
        </p>
        <a matTooltip="Clear" (click)="clear()" class="remove-file"
          ><mat-icon>close</mat-icon></a
        >
        }@else {
        <p>Browse file to upload (MAX 5 MB)</p>
        <input
          accept=".pdf, .xls, .xlsx,.png, .jpeg"
          (change)="
            Global.onFileUploadedToBase64(
              formGroup,
              $event,
              'documentData',
              toastr,
              [
                'application/pdf',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'image/jpeg',
                'image/png'
              ],
              'documentName',
              [
                'application/pdf',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'image/jpeg',
                'image/png'
              ]
            )
          "
          type="file"
        />
        }
      </div>
    </div>
    <div class="col-lg-12 col-12 mt-3">
      <label
        >Contact Number @if (Global.isInputRuleAvailable(formGroup, 'contactNo',
        'required')) { <span class="text-danger">*</span>}
      </label>
      <mat-form-field class="w-100">
        <input
          matInput
          formControlName="contactNo"
          [class.is-invalid]="!Global.isInputValid(formGroup, 'contactNo')"
          placeholder="Type Here"
        />
        @if (!Global.isInputRuleValid(formGroup, 'contactNo', 'required')) {
        <mat-error>This field is required</mat-error>
        }
        @if (!Global.isInputRuleValid(formGroup, 'contactNo', 'pattern')) {
            <mat-error>Invalid contact number</mat-error>
            }
      </mat-form-field>
    </div>
    <div class="col-lg-12 col-12">
      <label
        >Convenient @if (Global.isInputRuleAvailable(formGroup, 'requestCallDate',
        'required')) { <span class="text-danger">*</span>}
      </label>
      <div class="d-flex">
        <mat-form-field class="w-70 date">
            <input
              formControlName="requestCallDate"
              [max]="formGroup.value.tripEnds"
              matInput
              [disabled]="true"
              [matDatepicker]="picker"
              placeholder="DD/MM/YYYY"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker disabled="false"></mat-datepicker>
            @if (!Global.isInputRuleValid(formGroup, 'requestCallDate', 'required')) {
            <mat-error>This field is required</mat-error>
            }
          </mat-form-field>
          <input type="time" [class.is-invalid]="!Global.isInputValid(formGroup, 'requestCallTime')" formControlName="requestCallTime" class="form-control w-30 time">
      </div>
    </div>
  </div>
  <div class="p-3">
    <button
      type="button"
      class="btn btn-primary w-100"
      (click)="onSubmit($event)"
    >
      <span class="indicator-label"> Send Request</span>
      <span class="indicator-progress"
        >Please wait...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </button>
  </div>
</div>

